export default {
  computed: {
    isXs() {
      return this.$vuetify.display.xs;
    },
    isSm() {
      return this.$vuetify.display.sm;
    },
    isMd() {
      return this.$vuetify.display.md;
    },
    isASGS() {
      return (this.userInfo?.affiliation || '').trim() === '안산강서고';
    },
  },
};
